import { Skeleton } from "../ui/skeleton";

const CallLoader = () => {
	return (
		<div className="flex items-center justify-center w-full h-full gap-2 p-2">
			<div className="flex flex-col gap-6 items-center">
				<Skeleton className="w-24 h-9 rounded-lg" />
				<div className="flex gap-4">
					<Skeleton className="w-80 h-60 rounded-lg" />
					<Skeleton className="w-80 h-60 rounded-lg" />
				</div>
				<Skeleton className="w-24 h-9 rounded-lg self-end" />
			</div>
		</div>
	);
};

export default CallLoader;
